import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74451 7.88965L14.5 7.88965",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.40713,
			cy: 7.91311,
			r: 1.40713,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74451 3.13361L14.5 3.13361",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.40713,
			cy: 3.15707,
			r: 1.40713,
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74451 12.8194L14.5 12.8194",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.40713,
			cy: 12.8429,
			r: 1.40713,
			stroke: "currentColor"
		})
	]
});
export default SvgTransactions;
